import { Injectable, inject } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { AuthService } from '@shared/services/auth.service'

@Injectable({ providedIn: 'root' })
export class DashboardGuard {
  private authService = inject(AuthService)
  private router = inject(Router)

  async canActivate(): Promise<boolean | UrlTree> {
    const customer = this.authService.customer() ?? (await this.authService.ensureCustomerLoaded())
    if (customer) {
      if (this.authService.isNewCustomer) {
        return this.authService.isSetupRequired() ? this.router.parseUrl('/dashboard-visa/setup') : true
      } else {
        return this.router.parseUrl('/dashboard/home')
      }
    }
    return this.router.parseUrl('/dashboard-visa/login')
  }
}
